import React, { useState, useEffect } from 'react';
import NewsletterSignupForm from './NewsletterSignupForm';
import './NewsletterPopup.css';

interface NewsletterPopupProps {
  onClose?: () => void;
}

const NewsletterPopup: React.FC<NewsletterPopupProps> = ({ onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [, setHasBeenShown] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    // Check if user has already seen the popup or subscribed
    const popupShown = localStorage.getItem('businessTipsPopupShown');
    const isSubscribed = localStorage.getItem('businessTipsSubscribed');

    if (!popupShown && !isSubscribed) {
      // Show popup at random time between 3 and 30 seconds
      const randomDelay = Math.floor(Math.random() * (30000 - 3000 + 1)) + 3000;
      const timer = setTimeout(() => {
        setIsVisible(true);
        setHasBeenShown(true);
      }, randomDelay);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('businessTipsPopupShown', 'true');
    if (onClose) onClose();
  };

  const handleSuccess = () => {
    setShowSuccess(true);
    localStorage.setItem('businessTipsSubscribed', 'true');
    localStorage.setItem('businessTipsPopupShown', 'true');

    // Auto-close after showing success message
    setTimeout(() => {
      setIsVisible(false);
      setShowSuccess(false);
    }, 3000);
  };

  if (!isVisible) return null;

  return (
    <div className="newsletter-popup-overlay" onClick={handleClose}>
      <div className="newsletter-popup-modal" onClick={(e) => e.stopPropagation()}>
        <button className="newsletter-popup-close" onClick={handleClose}>
          &times;
        </button>
        {showSuccess ? (
          <div className="newsletter-success-message">
            <h2>🎉 Success!</h2>
            <p>You're all set to receive weekly business tips!</p>
            <p className="small">Check your email for confirmation.</p>
          </div>
        ) : (
          <NewsletterSignupForm
            onSuccess={handleSuccess}
            onDismiss={handleClose}
            source="popup"
          />
        )}
      </div>
    </div>
  );
};

export default NewsletterPopup;